import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ContentService} from './content.service';
import {forkJoin, Observable} from 'rxjs';
import {ContentBase} from '../interfaces/content-base';

const QR_ID_REMAP: Record<number, number> = {
  15310: 15295,
  15295: 15310,
  15305: 15301,
  15301: 15305,
  15307: 15298,
  15298: 15307,
};

@Injectable({
  providedIn: 'root'
})
export class PatternResolverService implements Resolve<any> {

  constructor(
    private contentService: ContentService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | ContentBase {

    let id = 0;
    const paramId = route.paramMap.get('id');

    if (paramId) {
      id = QR_ID_REMAP[parseInt(paramId, 10)] ?? parseInt(paramId, 10);
    }

    return forkJoin({
      contentBase: this.contentService.getContentById(id),
    });
  }
}
